module.exports = __webpack_public_path__ + "static/lageplan_freizeitsport_mini-a0de3800819a038b3a744aa5837c061f.png";